import { patchItem } from 'common/api/v1/panelModules';
import { setCeilZone } from 'common/components/segment/asceHelpers';
import { POLYGON_RECTANGLE } from 'common/components/segment/constants';
import {
    getDictionaryById,
    getQuantityEnabledModules,
    markGroupEdges,
    prepareModulesGroups,
    getModulesGroupV2,
} from 'common/components/segment/helpers';

import {
    CHANGE_MODULE_STATUS,
    CHANGE_MODULE_STATUS_FAILURE,
    CHANGE_MODULE_STATUS_SUCCESS,
} from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';
import * as selectors from '../selectors';

import patchGroup from './patchGroup';
import updateSegments from './updateSegments';

export default (moduleObject) => (dispatch, getState) => {
    const state = getState();
    const segments = selectors.getSegmentsData(state);
    const segmentsDictionary = getDictionaryById(segments);
    const parentSegment = segmentsDictionary[moduleObject.parentId];
    const currentValue = moduleObject.moduleEnable;
    const newValue = { is_enable: !currentValue, is_hidden: false };

    const { cell, col, group, row, google } = moduleObject;
    const {
        grouped_cells,
        solar_modules,
        drawing_type,
        building_height,
        ceil_tilt,
        building_heading,
        polygon,
        sloof_type,
    } = parentSegment;

    let asce_metadata = [];
    let grouped = [];
    let modules_groups = [];
    let groups = [];

    if (grouped_cells.length) {
        grouped = JSON.parse(JSON.stringify(grouped_cells));
        grouped[group][cell][row][col] = {
            ...grouped_cells[group][cell][row][col],
            enable: !currentValue,
        };

        modules_groups = getModulesGroupV2(grouped);
        groups = prepareModulesGroups(modules_groups);

        if (drawing_type === POLYGON_RECTANGLE && sloof_type !== '') {
            const markedGroupEdges = markGroupEdges(modules_groups);

            asce_metadata = setCeilZone({
                buildingHeight: building_height,
                ceilTilt: ceil_tilt,
                google,
                groups: markedGroupEdges,
                heading: building_heading,
                polygon,
                sloofType: sloof_type,
            });
        }
    }

    moduleObject.handleModuleEnableStatus(newValue.is_enable);

    dispatch(panelLayoutV2Actions[CHANGE_MODULE_STATUS]());

    patchItem(moduleObject.id, newValue)
        .then((response) => {
            const mutatedSolarModules = solar_modules.map((module) =>
                module.id === moduleObject.id
                    ? { ...module, enabled: !currentValue }
                    : module,
            );
            const quantityEnabledModules =
                getQuantityEnabledModules(mutatedSolarModules);
            const updatedSegment = {
                ...parentSegment,
                grouped_cells: grouped,
                quantity_enabled_modules: quantityEnabledModules,
                solar_modules: mutatedSolarModules,
                solar_modules_number: quantityEnabledModules,
                modules_groups,
            };
            const newValuesSegments = segments.map((segment) =>
                segment.id === updatedSegment.id
                    ? { ...segment, ...updatedSegment }
                    : segment,
            );

            dispatch(updateSegments(newValuesSegments));

            dispatch(
                panelLayoutV2Actions[CHANGE_MODULE_STATUS_SUCCESS](response),
            );

            dispatch(patchGroup(parentSegment.id, groups, asce_metadata));
        })
        .catch((error) => {
            moduleObject.handleModuleEnableStatus(currentValue);
            dispatch(panelLayoutV2Actions[CHANGE_MODULE_STATUS_FAILURE](error));
        });
};
